import { render } from "./Agreement.vue?vue&type=template&id=2ce08454&scoped=true"
const script = {}

import "./Agreement.vue?vue&type=style&index=0&id=2ce08454&scoped=true&lang=css"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce08454"]])

export default __exports__